module.exports = __webpack_public_path__ + "img/web1.a9c97ea2.png";